// Copyright (c) 2026. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted
import type { Theme } from '@mui/material';

// Resolve either a raw hex color ('#6366F1') or an MUI palette token
// ('success.main') against the active theme. Returns the hex/rgba string
// usable inside a `linear-gradient` rule — the MUI sx prop would resolve
// tokens automatically, but CSS gradient syntax is a raw string and
// needs the concrete color up front. Only handles the specific tokens
// used by the SEGMENTS list; unknown tokens pass through unchanged.
export function resolveBarColor(theme: Theme, token: string): string {
  if (token.startsWith('#')) return token;
  switch (token) {
    case 'success.main':
      return theme.palette.success.main;
    case 'text.secondary':
      return theme.palette.text.secondary;
    case 'error.main':
      return theme.palette.error.main;
    case 'primary.main':
      return theme.palette.primary.main;
    default:
      return token;
  }
}
